import { useTranslation } from 'react-i18n-lite'

import { Icon } from '@yes.technology/react-toolkit'

import { PhotoMark } from 'modules/interaction/components/ActivityInput/ActivityMarkPhoto/PhotoMarkingModal'
import {
  MarkBadge,
  MarkOverlay,
  MarksOverlayLayer
} from 'modules/interaction/components/ActivityInput/ActivityMarkPhoto/ActivityMarkPhoto.styles'
import { useRef } from 'react'

type Props = {
  image: string
  onCancel: () => void
  marks?: PhotoMark[]
}

const ViewPhoto = ({ image, onCancel, marks }: Props) => {
  const { t } = useTranslation()

  const imgRef = useRef<HTMLImageElement | null>(null)

  return (
    <div
      className='webcam d-flex flex-column w-100 h-100 position-fixed  justify-content-center align-items-center'
      style={{
        background: '#ffffff',
        top: '0',
        right: '0',
        bottom: '0',
        left: '0',
        zIndex: 2
      }}
    >
      <div className='webcam-header-view'>
        <div className='webcam-header-elements'>
          <button type='button' className='icon-button' onClick={onCancel}>
            <Icon iconName='Close' icSize='small' />
          </button>
          <span>{t('activity-document-photo.webcam.view')}</span>
        </div>
      </div>
      <div
        className='position-relative overflow-hidden'
        style={{ flex: 1, width: 'fit-content' }}
      >
        <img
          ref={imgRef}
          src={image}
          className='img-fluid'
          style={{ maxHeight: '100%' }}
          alt={t('activity-document-photo.webcam.screenshot')}
        />

        {marks && (
          <MarksOverlayLayer
            style={{
              height: imgRef.current?.clientHeight,
              width: imgRef.current?.clientWidth
            }}
          >
            {marks.map((mark, index) => (
              <MarkOverlay
                key={index}
                x={mark.x}
                y={mark.y}
                width={mark.width}
                height={mark.height}
              >
                <MarkBadge>{`#${index + 1} | ${mark.category.des}`}</MarkBadge>
              </MarkOverlay>
            ))}
          </MarksOverlayLayer>
        )}
      </div>
    </div>
  )
}

export default ViewPhoto
